import React from 'react';
import { FormControlLabel, FormGroup, Checkbox as MUCheckbox } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { color } from '../theme';

const useStyles = makeStyles()({
  rootBlack: {
    color: color.black,
    '&$checked': {
      color: color.black,
    },
  },
  rootGreen: {
    color: color.primaryButton,
    '&$checked': {
      color: color.primaryButton,
    },
  },
  container: {
    height: '100%',
    width: '55%',
    marginTop: 5,
    marginBottom: 5,
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  checkbox: {
    display: 'flex',
    justifyContent: 'flex-start',
    maxWidth: 30,
    color: color.black,
    fontWeight: 400,
    fontSize: '14px',
    '&$checked': {
      color: color.black,
    },
  },
  checked: {},
  header: {
    display: 'flex',
    justifyContent: 'flex-start',
    color: color.black,
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '21px',
    marginTop: 15,
    width: '40%',
    minWidth: 500,
  },
  labelText: {
    color: color.black,
  },
});

interface Props {
  data: { name: string; [key: string]: unknown }[];
  selectedData: Record<string, boolean>;
  isBlack?: boolean;
  onChange: (value: { name: string; checked: boolean }) => void;
}

function Checkbox(props: Props) {
  const { classes } = useStyles();
  const { data, selectedData, onChange, isBlack } = props;

  return (
    <div className={classes.container}>
      <FormGroup row={false} className={classes.formGroup}>
        {data.map((item: { name: string }, index: number) => (
          <FormControlLabel
            key={index}
            classes={{
              label: classes.labelText,
            }}
            control={
              <MUCheckbox
                checked={!!selectedData[item.name]}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  onChange({ name: e.target.name, checked: e.target.checked })
                }
                name={item.name}
                className={isBlack ? classes.rootBlack : classes.rootGreen}
              />
            }
            label={item.name}
          />
        ))}
      </FormGroup>
    </div>
  );
}

export default Checkbox;
